<script lang="ts" module>
	import { isEnum } from "@core/utils/enum/isEnum.js";
	import type { ButtonVariant } from "./getButtonClass.js";
	import { LinkVariant, getLinkClass } from "./getLinkClass.js";

	const isLinkVariant = isEnum(LinkVariant);
</script>

<script lang="ts">
	import AriaText from "@components/common/AriaText.svelte";
	import type { HTMLAnchorAttributes } from "svelte/elements";
	import { getButtonClass } from "./getButtonClass.js";

	const {
		variant = LinkVariant.Default,
		...rest
	}: { variant: ButtonVariant | LinkVariant } & Omit<HTMLAnchorAttributes, "download"> & { download?: string } =
		$props();
</script>

<a {...rest} class={[isLinkVariant(variant) ? getLinkClass(variant) : getButtonClass(variant), rest.class]}>
	<AriaText aria={rest["aria-label"] ?? ""}>
		{@render rest.children?.()}
	</AriaText>
</a>
